import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './core/services/base.service';
import { Environment } from './core/environment/environment';
import { forkJoin } from 'rxjs';
import { IResponse } from './shared/models/app';
import { AuthService } from './core/services/auth.service';
import { TokenService } from './core/services/token.service';

@Injectable({
  providedIn: 'root',
})
export class AppService extends BaseService {
  /*********************Properties*********************/
  /*********************Properties*********************/

  /*********************Events/Observables*********************/
  /*********************Events/Observables*********************/

  /*********************Constructor*********************/
  constructor(
    protected http: HttpClient,private authService: AuthService,
    private token : TokenService

  ) {
    super(http);
  }
  /*********************Constructor*********************/

  /*********************Utility Methods*********************/

  init() {
    
  }

  initOnLoad(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(true);
      // if (
      //   this.isDown() ||
      //   this.userService.isInternalUser()
      // ) {
      //   resolve(true);
      //   return;
      // }

      // this.authService.isAuthenticated().then((response: AuthValidate) => {
      //   resolve(response.authenticated.all);
      // });
    });
  }

  isDown(): boolean {
    const config = Environment.getInstance().appConfig.app;
    const isAppDown = config.down;

    return isAppDown;
  }

  /*********************Utility Methods*********************/

  /*********************Service Methods*********************/

  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.token.init();
      const accounts = this.authService.authorize();
      const requests: any = forkJoin(accounts);
      requests.subscribe((response: IResponse[]) => {
        const hasError = response.find(res => res.hasError) ? true : false;

        // if (tokenExist && response[2] && !hasError) {
        //   // const user: User = response[1].data;
        //   // this.userService.init(user);
        // }

        // Environment.getInstance().appConfig.app.hasError = hasError;
        resolve(true);
      });
    });
  
  }

  /*********************Service Methods*********************/

  /*********************Private Methods*********************/

  /*********************Private Methods*********************/
}
